@import '../../../../../../src/app-brand/entities/entity-layer.module.less';

.completed-icon {
  width: 18px;
  height: 18px;
  color: @batches--processing-completed--svg--fill-color;
}

.processing-column-cell {
  display: flex;
  align-items: center;
  height: 100%;
}

.complete-link {
  margin-left: 8px;
  font-size: 13px;
}

.progress-pusher-aware {
  & .descendent {
    font-size: 13px;
    line-height: 1.4;
  }
}
